import mixin from '../mixins/mixin';
import Observable from '../mixins/observable';
import $ from 'jquery';
/*

broadcast events:

    onChange([{"id": <int>, "type": <string>, "lat": <float>, "lng": <float>}, ...])
    onSelect({"old": <int> or null - old location id, "new": <int> - new location id})
    onUnselect(<int> - location id)
    onLocationBlur(<int> - location id)
    onLocationFocus(<int> - location id)

 */

function MapModel(markerData, ajaxHtmlrequestUrl) {
  this.markerData = {};
  this.ajaxHtmlrequestUrl = ajaxHtmlrequestUrl;
  this.activeLocation = null;
  this.selectedLocation = null;
  this.parseMarkerData(markerData);
}

MapModel.prototype = mixin({}, Observable, {
  parseMarkerData(markerData) {
    if (Array.isArray(markerData) === false) {
      return;
    }

    markerData.forEach(marker => {
      this.markerData[marker.id] = marker;
    });
  },

  getMarkerData(id) {
    if (typeof this.markerData[id] !== 'undefined') {
      return this.markerData[id];
    }
    return null;
  },

  getMarkerHtml(id) {
    return new Promise((resolve, reject) => {
      $.ajax(this.ajaxHtmlrequestUrl, {
        data: {
          camp_id: id,
        },
        success: function(responseObj) {
          resolve({
            html: responseObj,
          });
        }.bind(this),
        error(jqXHR, textStatus, errorThrown) {
          reject(new Error(errorThrown));
        },
        dataType: 'html',
        method: 'POST',
      });
    });
  },

  getMarkerMapData() {
    const markerList = [];
    for (let id in this.markerData) {
      markerList.push(this.markerData[id]);
    }
    return markerList;
  },

  selectLocation(locationId) {
    if (this.selectedLocation !== locationId) {
      const oldSelection = this.selectedLocation;
      this.selectedLocation = locationId;
      this.notifyListeners('onSelect', {
        old: oldSelection,
        new: this.selectedLocation,
      });
    }
  },

  unselectLocation() {
    if (this.selectedLocation !== null) {
      this.notifyListeners('onUnselect', this.selectedLocation);
      this.selectedLocation = null;
    }
  },

  setLocationActive(locationId) {
    if (this.activeLocation !== locationId) {
      if (this.activeLocation !== null) {
        this.notifyListeners('onLocationBlur', this.activeLocation);
      }
      this.activeLocation = locationId;
      this.notifyListeners('onLocationFocus', this.activeLocation);
    }
  },

  setLocationInactive() {
    if (this.activeLocation !== null) {
      this.notifyListeners('onLocationBlur', this.activeLocation);
      this.activeLocation = null;
    }
  },

  getSelectedLocation() {
    return this.selectedLocation;
  },
});

export default MapModel;



// WEBPACK FOOTER //
// ./src/js/maps/MapModel.js